import { createContext, useContext, useEffect, useState } from 'react';
import { doc, getDoc, onSnapshot } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { useAuth } from './AuthContext';

const FamilyContext = createContext({});

export function FamilyProvider({ children }) {
  const [family, setFamily] = useState(null);
  const [loading, setLoading] = useState(true);
  const { user, familyId } = useAuth();

  useEffect(() => {
    if (!familyId) {
      setFamily(null);
      setLoading(false);
      return;
    }

    // Subscribe to family document
    const unsubscribe = onSnapshot(
      doc(db, 'families', familyId),
      (doc) => {
        if (doc.exists()) {
          setFamily({ id: doc.id, ...doc.data() });
        } else {
          setFamily(null);
        }
        setLoading(false);
      },
      (error) => {
        console.error('Error fetching family:', error);
        setLoading(false);
      }
    );

    return unsubscribe;
  }, [familyId]);

  const value = {
    family,
    familyId,
    loading,
  };

  return (
    <FamilyContext.Provider value={value}>
      {children}
    </FamilyContext.Provider>
  );
}

export const useFamily = () => {
  const context = useContext(FamilyContext);
  if (context === undefined) {
    throw new Error('useFamily must be used within a FamilyProvider');
  }
  return context;
};
